type SignInLocation = Pick<Location, "pathname" | "search" | "replace">;
type ReloadableLocation = Pick<Location, "reload">;
type AssignableLocation = Pick<Location, "assign">;

export function reloadToSignIn(location: SignInLocation = window.location) {
  const search = location.pathname === "/signin" ? location.search : "";
  location.replace(`/signin${search}`);
}

// A deployment can change the asset manifest, so a tab held open across one has
// to load the current document. Reloading in place keeps the URL, its query,
// and the session; only the stale assets are replaced.
export function reloadCurrentDocument(location: ReloadableLocation = window.location) {
  location.reload();
}

// When the current asset manifest is stale, load the user's next internal
// destination as a new document directly. Starting an SPA render and reloading
// it immediately afterwards races document replacement in Firefox and WebKit.
export function loadDocumentAt(path: string, location: AssignableLocation = window.location) {
  location.assign(path);
}
